import { MessagesSquare } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function InterviewGuideNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={MessagesSquare} selected={selected} />;
}
